<template>
  <div
    class="min-h-screen bg-navy flex flex-col justify-center py-10 sm:px-6 lg:px-8"
  >
    <div class="flex-center mt-8">
      <!-- <div class="flex-item flex-top"></div> -->

      <div class="w-[576px]" :class="wrapperClasses">
        <a
          href="/"
          class="absolute top-[30px] left-[30px] hover:no-underline hover:text-yellow-500"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="black"
            class="w-5 h-5 color"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
            />
          </svg>
        </a>
        <slot name="top">
          <a href="/" class="logo">
            <img
              alt="Vestbee"
              :src="imgSrc"
              class="mx-auto h-10"
              :class="{ 'mb-6': !title }"
            />
          </a>
          <div v-if="title">
            <p class="mt-6 text-center text-base font-semibold">
              {{ title }}
            </p>
          </div>
        </slot>
        <slot></slot>
      </div>
      <slot name="bottom"></slot>
    </div>
    <div class="flex-item flex-bottom"></div>
  </div>
</template>

<script>
export default {
  props: {
    loading: { type: Boolean, default: false },
    imgSrc: { default: '/static/images/vestbee_logo.svg' },
    title: {
      required: false,
      type: String,
    },
    withWrapper: {
      default: false,
      type: Boolean,
    },
    wrapperClasses: {
      default: 'bg-white py-8 px-4  shadow sm:rounded-xl sm:px-10 relative',
      type: String,
    },
  },
}
</script>
<style lang="scss" scoper>
.color:hover {
  filter: invert(62%) sepia(90%) saturate(379%) hue-rotate(6deg)
    brightness(102%) contrast(87%);
}
</style>
